import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/tools/thank-you-email-generator/ThankYouEmailContent.tsx");
